<template>
    <div>
        <p>
            <button class="btn btn-secondary btn-sm" type="button" @click.prevent="add"><span class="bi bi-plus-circle me-1"></span> Add</button>
        </p>
        <div class="list-of-fieldsets" v-for="(employment, key) in employments">
            <div class="row gx-3">
                <div class="col-sm-11">
                    <div class="row gx-3">
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'employment_employer_' + key">Employer</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'employments.employer.' + key in invalidData }"
                                type="text"
                                v-model="employment.employer"
                                name="employments[employer][]"
                                :id="'employment_employer_' + key"
                            />
                            <div class="invalid-feedback" v-if="'employments.employer.' + key in invalidData">
                                {{ invalidData['employments.employer.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'employment_employer_contact_' + key">Contact Email for Further Reference</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'employments.employer_contact.' + key in invalidData }"
                                type="email"
                                v-model="employment.employer_contact"
                                name="employments[employer_contact][]"
                                :id="'employment_employer_contact_' + key"
                            />
                            <div class="invalid-feedback" v-if="'employments.employer_contact.' + key in invalidData">
                                {{ invalidData['employments.employer_contact.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'employment_start_date_' + key">Start Date</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'employments.start_date.' + key in invalidData }"
                                type="date"
                                v-model="employment.start_date"
                                name="employments[start_date][]"
                                :id="'employment_start_date_' + key"
                            />
                            <div class="invalid-feedback" v-if="'employments.start_date.' + key in invalidData">
                                {{ invalidData['employments.start_date.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'employment_end_date_' + key">End Date</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'employments.end_date.' + key in invalidData }"
                                type="date"
                                v-model="employment.end_date"
                                name="employments[end_date][]"
                                :id="'employment_end_date_' + key"
                            />
                            <div class="invalid-feedback" v-if="'employments.end_date.' + key in invalidData">
                                {{ invalidData['employments.end_date.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'employment_type_' + key">Type</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'employments.type.' + key in invalidData }"
                                type="text"
                                v-model="employment.type"
                                name="employments[type][]"
                                :id="'employment_type_' + key"
                            />
                            <div class="invalid-feedback" v-if="'employments.type.' + key in invalidData">
                                {{ invalidData['employments.type.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'employment_function_' + key">Function</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'employments.function.' + key in invalidData }"
                                type="text"
                                v-model="employment.function"
                                name="employments[function][]"
                                :id="'employment_function_' + key"
                            />
                            <div class="invalid-feedback" v-if="'employments.function.' + key in invalidData">
                                {{ invalidData['employments.function.' + key][0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-1 mb-3 d-flex align-items-end">
                    <button class="btn btn-link text-danger" type="button" @click.prevent="remove(employment)">Remove</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        initEmployments: {
            type: Array,
            required: true,
        },
        invalidData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            employments: this.initEmployments,
        };
    },
    methods: {
        newEmployment() {
            return {
                employer: '',
                employer_contact: '',
                start_date: '',
                end_date: '',
                type: '',
                function: '',
            };
        },
        add() {
            this.employments.push(this.newEmployment());
        },
        remove(employment) {
            var index = this.employments.indexOf(employment);
            this.employments.splice(index, 1);
        },
    },
};
</script>
